import type { ToolUseStatus } from '../../harness.types';

/**
 * Build a `ToolUseStatus → block render-status` mapper. `running` and `queued`
 * (call received, execution not yet observed) both map to the in-progress
 * state so a known Evidence tool renders its loading block from the call
 * receipt instead of flashing the generic row first; `cancelled` /
 * `pending_approval` / `streaming_input` map to `null` (the dispatcher
 * handles those). The literal
 * argument types are preserved in each mapper's return union, so call sites
 * type-check exactly as the per-tool variants did.
 */
export const makeStatusMapper =
  <InProgress extends string, Completed extends string, Errored extends string>(
    inProgress: InProgress,
    completed: Completed,
    errored: Errored
  ) =>
  (status: ToolUseStatus): InProgress | Completed | Errored | null => {
    switch (status) {
      case 'running':
      case 'queued':
        return inProgress;
      case 'complete':
        return completed;
      case 'error':
        return errored;
      case 'cancelled':
      case 'pending_approval':
      case 'streaming_input':
        return null;
    }
  };
